export const loadScript = (data: {
  src?: string;
  innerHTML?: string;
}): Promise<unknown> =>
  new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    if (data.src) {
      script.src = data.src;
      script.onload = () => {
        resolve(undefined);
      };
      script.onerror = (error) => {
        reject(error);
      };
    }
    if (data.innerHTML) {
      script.innerHTML = data.innerHTML;
    }
    document.head.appendChild(script);
    if (!data.src) {
      resolve(undefined);
    }
  });
